import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import loadable from '../../../loadable';
import Category from './Category';
import BeautyOffersIcon from '../../../../images/icons/categories/beauty-offers-icon.svg';
import StarsIcon from '../../../../images/icons/categories/bestsellers-icon.svg';
import TheLabIcon from '../../../../images/icons/categories/the-lab-icon.svg';
import ShopAllIcon from '../../../../images/icons/categories/shopall-icon.svg';
import AccountIcon from '../../../../images/icons/categories/account-icon.svg';
import styles from './StickyCategories.module.sass';
import { userObjectSelector } from '../../../user/selectors/user';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import { modalsActions } from '../../../modals/actions';
import MODALS from '../../../modals/constants/modals';

const AccountDropdown = loadable(() => import('../../../header/components/dropdown/account_dropdown/AccountDropdown'));

const NAVIGATION_LINKS = {
  SHOP: '/shop/',
  BESTSELLERS: '/shop/t/categories/featured/best-selling-skin-care/',
  BEAUTY_OFFERS: '/shop/t/categories/30-75-percent-off-beauty-offers/',
  THE_LAB: '/the-lab/',
};

class StickyCategories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMobileMenu: false,
    };
  }

  openLoginDialog = () => {
    const { openLoginDialog } = this.props;
    Cookies.set('signed_up_from', 'menu_signup');
    window.userLoggedInCallback = null;
    openLoginDialog();
  };

  onMobileMenuToggleClick = () => {
    this.setState((prevState) => ({
      showMobileMenu: !prevState.showMobileMenu,
    }));
  };

  onMobileMenuCloseClick = () => {
    this.setState({ showMobileMenu: false });
  };

  render() {
    const { user } = this.props;
    const { showMobileMenu } = this.state;

    return (
      <>
        <div className={styles['sticky-wrapper']}>
          <div className={styles.categories}>
            <Category name="Shop All" link={NAVIGATION_LINKS.SHOP} img={ShopAllIcon} />
            <Category name="Beauty Offers" link={NAVIGATION_LINKS.BEAUTY_OFFERS} img={BeautyOffersIcon} />
            <Category name="Bestsellers" link={NAVIGATION_LINKS.BESTSELLERS} img={StarsIcon} />
            <Category name="Upcoming" link={NAVIGATION_LINKS.THE_LAB} img={TheLabIcon} />
            { !user && (
              <ClickableDiv className={styles.category} onClick={this.openLoginDialog}>
                <span>Sign in</span>
                <img src={AccountIcon} alt="sign-in" />
              </ClickableDiv>
            )}
            { user && (
              <ClickableDiv className={styles.category} onClick={this.onMobileMenuToggleClick}>
                <span>Account</span>
                <img src={AccountIcon} alt="account" />
              </ClickableDiv>
            )}
          </div>
        </div>
        { showMobileMenu && (
          <AccountDropdown onCloseClick={this.onMobileMenuCloseClick} />
        )}
      </>
    );
  }
}

StickyCategories.propTypes = {
  openLoginDialog: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
};

StickyCategories.defaultProps = {
  user: null,
};

const mapStateToProps = (state) => ({
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  openLoginDialog: () => dispatch(modalsActions.openModalRequest({ modal: MODALS.SIGN_IN })),
});

export default connect(mapStateToProps, mapDispatchToProps)(StickyCategories);
